import axios from "axios";

export default {
    update(data) {
        return axios({
            method: "put",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/footer",
            data: data,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAll() {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/footer",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllPublic() {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "public/footer",
        });
    },
};
